import classNames from 'classnames';
import { ReactNode, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import UserImage2Webp from '../../assets/img/wanna/wanna1.webp';
import Button from '../../components/bootstrap/Button';
import Collapse from '../../components/bootstrap/Collapse';
import { DropdownItem, DropdownMenu } from '../../components/bootstrap/Dropdown';
import Icon from '../../components/icon/Icon';
import ThemeContext from '../../contexts/themeContext';
import useNavigationItemHandle from '../../hooks/useNavigationItemHandle';
import { demoPagesMenu } from '../../menu';
import { NavigationLine } from '../Navigation/Navigation';
import { clearPageCache } from '../../utils/cache';
import AuthContext from '../../contexts/authContext';

const User = () => {
	const { width } = useWindowSize();
	const { setAsideStatus } = useContext(ThemeContext);
	const { logout } = useContext(AuthContext);

	const navigate = useNavigate();
	const handleItem = useNavigationItemHandle();

	const [collapseStatus, setCollapseStatus] = useState<boolean>(false);

	const { t } = useTranslation(['translation', 'menu']);

	let user: any = {};

	try {
		const raw = localStorage.getItem('neels_authUsername');

		if (raw && raw !== 'undefined' && raw !== 'null') {
			user = JSON.parse(raw);
		}
	} catch (err) {
		console.warn('Invalid user data in localStorage', err);
		user = {};
	}
	const handleLogout = async () => {
		await logout();
		navigate(`../${demoPagesMenu.login.path}`, { replace: true });
	};

	return (
		<>
			{/* <div
				className={classNames('data', { open: collapseStatus })}
				role='presentation'
				onClick={() => setCollapseStatus(!collapseStatus)}>
				<div className='d-flex'>
					<div className='data-avatar ms-3'>
						<img
							className='w-50 h-50 mt-2'
							// srcSet={data}
							src={user && user?.src ? user?.src : UserImage2Webp}
							alt='Avatar'
							width={128}
							height={128}
						/>
					</div>

					<div className='data-info'>
						<span className='data-name d-flex align-items-center fs-6'>
							{`${user?.username}`}
							<Icon icon='Verified' className='ms-1' color='info' />
						</span>
						<div className='data-sub-title fs-6'>{user?.email}</div>
					</div>
				</div>
			</div> */}
			<div
				className={classNames('user data', { open: collapseStatus })}
				role='presentation'
				onClick={() => setCollapseStatus(!collapseStatus)}>
				<div className='user-avatar'>
					<img
						// srcSet={userData?.srcSet}
						src={user && user?.src ? user?.src : UserImage2Webp}
						alt='Avatar'
						width={128}
						height={128}
					/>
				</div>
				<div className='user-info'>
					<div
						className='user-name d-flex align-items-center'
						style={{ overflowWrap: 'anywhere' }}>{`${user?.username}`}</div>
					<div className='user-sub-title' style={{ overflowWrap: 'anywhere' }}>
						{user?.email}
					</div>
				</div>
			</div>
			{/* <DropdownMenu>
				<DropdownItem>
					<Button icon='AccountBox' onClick={() => navigate('/profile/update')}>
						Profile
					</Button>
				</DropdownItem>
			</DropdownMenu> */}

			<Collapse isOpen={collapseStatus} className='data-menu'>
				{/* <nav aria-label='aside-bottom-data-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								navigate(
									`/profile/update`,
									// @ts-ignore
									handleItem(),
								);
								setCollapseStatus(!collapseStatus);
							}}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon icon='AccountBox' className='navigation-icon' />
									<span className='navigation-text'>
										{t('menu:Profile') as ReactNode}
									</span>
								</span>
							</span>
						</div>
					</div>
				</nav> */}
				<NavigationLine />
				<nav aria-label='aside-bottom-data-menu-2'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							// onClick={() => {
							// 	// if (setUser) {
							// 	// 	setUser('');
							// 	// }
							// 	localStorage.clear();
							// 	clearPageCache('*'); //clear everything
							// 	if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
							// 		setAsideStatus(false);
							// 	}
							// 	localStorage.clear();
							// 	clearPageCache('*'); //clear everything
							// 	navigate(`../${demoPagesMenu.login.path}`);
							// }}
							onClick={handleLogout}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon icon='Logout' className='navigation-icon' />
									<span className='navigation-text'>
										{t('menu:Logout') as ReactNode}
									</span>
								</span>
							</span>
						</div>
					</div>
				</nav>
			</Collapse>
		</>
	);
};

export default User;
